import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

// For third-party inputs that own their DOM and expose no slot to render an icon
// element into — mui-tel-input's calling-code adornment is the case that forced
// this. Painting the glyph as a CSS mask on a pseudo-element keeps the shape
// sourced from the catalog instead of a path copied into the component.
export function faIconMaskUrl(icon: IconDefinition): string {
  const [width, height, , , path] = icon.icon;
  const d = Array.isArray(path) ? path.join(' ') : path;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"><path d="${d}"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}
